import React from 'react';
import MergeModal from 'candidate_profile_redesign/modals/merge_modal';
import { useCandidateProfile } from 'candidate_profile_redesign/store';

type Props = {
  onModalOpenReady: (openFn: () => void) => void;
  onMergeSuccess?: () => void;
};

/**
 * Wrapper component that bridges the talent matching context with the candidate profile
 * merge modal. Must be rendered inside CandidateProfileWrapper.
 */
const MergeModalWrapper = ({ onModalOpenReady, onMergeSuccess }: Props) => {
  const {
    actions: { useGlobalModal },
  } = useCandidateProfile();

  const { openModal } = useGlobalModal('mergeModal');

  React.useEffect(() => {
    onModalOpenReady(() =>
      openModal({ leaveSeparate: true, onSuccess: onMergeSuccess })
    );
  }, [openModal, onModalOpenReady, onMergeSuccess]);

  return <MergeModal />;
};

export default MergeModalWrapper;
